import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import AutoIncrementorOptionsCard from '../../../../custom-components/schedule2/Dialogs/MilkSupplyItemDialog/AutoIncrementor/AutoIncrementorOptionsCard';

const POIncrementorOptions = ({ name, props }) => {
    const { control, setValue, getValues } = useFormContext();
    const [item, setItem] = useState(null);

    useEffect(() => {
        if (item) {
            const existingItem = getValues(name);
            setValue(name, { ...existingItem, ...item });
        }
    }, [item]);

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => <AutoIncrementorOptionsCard item={item} setItem={setItem} />}
            // wrap
        />
    );
};

export default POIncrementorOptions;
